import React, {useState} from 'react'
import {LineChart, Line, XAxis, YAxis, Tooltip} from 'recharts'

let Charts = ({datas, activeName, screenHeight, screenWidth, sitesArr}) => {
  const [hovered, setHovered] = useState(null)

  let formatX = dateString => dateString.toString().substring(5)

  let width = screenWidth - 200
  let height = screenHeight - 300

  let useData = sitesArr.map(site => {
    return {
      data: datas[site.name],
      name: site.name,
    }
  })

  const colors = ['#8884d8', '#82ca9d', '#228b22', '#ff7300', '#413ea0', '#003366', '#aa336a']

  const CustomTooltip = ({active, payload, label, hovered}) => {
    if (active && payload && hovered != null) {
      console.log('hovered', hovered, payload)

      const currentPayload = payload.find((p, k) => k == hovered)
      console.log('currentPayload', currentPayload)

      if (currentPayload) {
        return (
          <div className="custom-tooltip" style={{backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc'}}>
            <p>{label}</p>
            <p style={{color: currentPayload.color}}>
              {currentPayload.name}: {currentPayload.value}
            </p>
          </div>
        )
      }
    }

    return null
  }

  return (
    <div style={{opacity: 0.6}}>
      <LineChart width={width} height={height} data={useData}>
        {useData.map((site, k) => (
          <Line
            key={k}
            data={site.data}
            name={site.name}
            type="monotone"
            dataKey="users"
            stroke={colors[k % colors.length]}
            strokeWidth={hovered === k ? 2 : 1}
            dot={false}
            onMouseEnter={() => setHovered(k)}
            onMouseLeave={() => setHovered(null)}
          />
        ))}
        <Tooltip content={<CustomTooltip hovered={hovered} />} />

        <XAxis dataKey="adjustedDate" tickFormatter={formatX} tick={false} allowDuplicatedCategory={false} />
        <YAxis domain={[0, 10]} />
      </LineChart>
    </div>
  )
}

export default Charts
